import type { TSeat } from '@core/types';

export const DiscardAnnounceStyle = {
  UprightEnlarged: 'upright-enlarged',
} as const;

export type TDiscardAnnounceStyle =
  (typeof DiscardAnnounceStyle)[keyof typeof DiscardAnnounceStyle];

const DISCARD_ANNOUNCE_PRESENTATIONS: Record<
  TSeat,
  { readonly x: number; readonly y: number; readonly style: TDiscardAnnounceStyle }
> = {
  0: { x: 640, y: 505, style: DiscardAnnounceStyle.UprightEnlarged }, // 本家手牌上方中央
  1: { x: 1170, y: 360, style: DiscardAnnounceStyle.UprightEnlarged }, // 右家手牌左側
  2: { x: 640, y: 190, style: DiscardAnnounceStyle.UprightEnlarged }, // 對家手牌下方中央
  3: { x: 170, y: 360, style: DiscardAnnounceStyle.UprightEnlarged }, // 左家手牌右側
};

/** 原版四家 mDiscardTile 的門前位置與呈現方式。 */
export const discardAnnouncePresentationForSeat = (
  seat: TSeat
): { readonly x: number; readonly y: number; readonly style: TDiscardAnnounceStyle } =>
  DISCARD_ANNOUNCE_PRESENTATIONS[seat];
